export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/newsletters?${queryString}`)
        .then(response => {
          context.commit("addNews", response.data.results);
          context.commit("setCount", response.data.count);
          resolve(response.data.results);
        })
        .catch(reject);
    });
  }
};
